import React from "react";
import {GraphQlSelectId} from "./GraphQlSelectId";
import {GraphQlSelect} from "./GraphQlSelect";
import { usePaymentTermQueryQuery } from "../../generated/graphql";
export const PaymentTermSelect = (props) => {
    const query = usePaymentTermQueryQuery();
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="label" />:<GraphQlSelect queryResult={query} {...props}  labelField="name" />;
}